import { HTMLAttributes, useRef, useState, useEffect } from "react";
import { Styles, GlobalScrollbarStyle } from "./styled";
import CustomVerticalScrollBar from "../CustomVerticalScrollBar";
import CustomHorizontalScrollBar from "../CustomHorizontalScrollBar";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  offSetHeight?: number;
}
const BlockScrollInternal = ({ offSetHeight = 0, ...propsElement }: IProps) => {
  const refContainer = useRef<HTMLDivElement>(null);
  const [y, setY] = useState(0);

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout>;

    const updateY = () => {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        if (refContainer.current) {
          setY(refContainer.current.getBoundingClientRect().y + offSetHeight);
        }
      }, 400);
    };

    updateY();
    window.addEventListener("resize", updateY);
    window.addEventListener("scroll", updateY);
    return () => {
      clearTimeout(timerId);
      window.removeEventListener("resize", updateY);
      window.removeEventListener("scroll", updateY);
    };
  }, [refContainer.current]);

  return (
    <div>
      <GlobalScrollbarStyle />
      <div className="d-flex justify-end">
        <CustomHorizontalScrollBar element={refContainer.current} />
      </div>
      <div className="d-flex">
        <div>
          <CustomVerticalScrollBar element={refContainer.current} />
        </div>
        <Styles
          ref={refContainer}
          {...propsElement}
          style={{ height: `calc(100vh - ${y}px)`, ...propsElement.style }}
          className={`scroll_internal hidden-scrollbar ${
            propsElement.className || ""
          }`}
        />
      </div>
    </div>
  );
};

export default BlockScrollInternal;
